import {SwapFormState, SwapFormTextFieldNames} from "../SwapForm.types";

const initialSwapFormState: SwapFormState = {
  isReady: false,
  assetIn: {asset: null, [SwapFormTextFieldNames.AssetInAmount]: ""},
  assetOut: {
    asset: null,
    [SwapFormTextFieldNames.AssetOutAmount]: ""
  },
  quote: null,
  txnsToSign: null
};

const PRICE_IMPACT_WARNING_THRESHOLD = 0.05;

const SWAP_BUTTON_DISABLE_TIME_FOR_PRICE_IMPACT_WARNING = 5000;
const SWAP_ERROR_MESSAGE_TOOLTIP_DISPLAY_DURATION = 5000;

const DISCREPANCY_IN_GENERATED_SWAP_QUOTE_ERROR = new Error(
  "There is a discrepancy between the assets displayed and the generated quote. Please refresh the page and try again."
);

const DEFAULT_SWAP_FEE_RATE = 0.003;

export {
  initialSwapFormState,
  PRICE_IMPACT_WARNING_THRESHOLD,
  SWAP_BUTTON_DISABLE_TIME_FOR_PRICE_IMPACT_WARNING,
  DISCREPANCY_IN_GENERATED_SWAP_QUOTE_ERROR,
  DEFAULT_SWAP_FEE_RATE,
  SWAP_ERROR_MESSAGE_TOOLTIP_DISPLAY_DURATION
};
